import React, { useState } from 'react';
import { API_BASE } from '../App';

const CreateGeneralRequest = ({ user, token, onBack }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    priority: 'normal'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          type: 'genel',
          title: formData.title,
          description: formData.description,
          priority: formData.priority,
          product_id: null
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Genel talep başarıyla oluşturuldu!');
        setFormData({ title: '', description: '', priority: 'normal' });
        setTimeout(() => onBack(), 2000);
      } else {
        setMessage(data.error || 'Hata oluştu');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <div className="form-container">
        <button onClick={onBack} className="btn-back">Geri Dön</button>
        <h2>Genel Talep</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Talep Başlığı:</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              required
              placeholder="Talebinizi kısaca özetleyin"
            />
          </div>
          
          <div className="form-group">
            <label>Talep Detayı:</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              required
              rows="6"
              placeholder="Talebinizi detaylı olarak açıklayın..."
            />
          </div>
          
          <div className="form-group">
            <label>Öncelik:</label>
            <select
              value={formData.priority}
              onChange={(e) => setFormData({...formData, priority: e.target.value})}
            >
              <option value="low">Düşük</option>
              <option value="normal">Normal</option>
              <option value="high">Yüksek</option>
              <option value="urgent">Acil</option>
            </select>
          </div>
          
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Gönderiliyor...' : 'Genel Talep Oluştur'}
          </button>
        </form>
        
        {message && (
          <div className={`message ${message.includes('başarı') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateGeneralRequest;